// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"535":"login","587":"community","845":"profile","893":"products"}[chunkId] + "." + {"535":"dfd43af9","587":"cad723f9","845":"2a70e023","893":"b7cdf929"}[chunkId] + ".css";
};